// src/pages/ResetPasswordRequest.js

import React, { useState } from 'react';
import API from '../api';
import './login.css';
import './resetPassword.css';
import logo from '../assets/merchant-marvels.jpg';

const ResetPasswordRequest = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    setLoading(true);

    try {
      const res = await API.post('/auth/request-reset', { email });
      setStatus(res.data.message || 'Password reset link sent to your email.');
    } catch (error) {
      setStatus(
        (error.response && error.response.data && error.response.data.error) ||
          'Error sending reset link'
      );
    } finally {
      setLoading(false);
    }
  };

  const isError =
    typeof status === 'string' &&
    status.toLowerCase().includes('error');

  return (
    <div className="mm-login-container">
      {/* Left hero panel */}
      <div className="mm-login-left">
        <div className="mm-welcome-message">
          <h1>Welcome To Merchant Marvels</h1>
          <p>
            Enter your registered email address and we&apos;ll send you a link
            to reset your password.
          </p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="mm-login-right">
        <div className="mm-login-logo-wrapper">
          <img
            src={logo}
            alt="Merchant Marvels"
            className="mm-login-logo"
          />
        </div>

        <div className="mm-login-form-wrapper">
          <form onSubmit={handleSubmit} className="mm-login-form">
            <h2 className="mm-login-title">Forgot Password</h2>
            <p className="mm-login-subtitle">
              Email/ User Name
            </p>

            <div className="mm-input-wrapper">
              <input
                type="email"
                name="email"
                required
                placeholder="Enter Your Email"
                className="mm-login-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="mm-login-button"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Reset Password'}
            </button>

            {status && (
              <p className={isError ? 'rpw-error' : 'rpw-success'}>
                {status}
              </p>
            )}

            <p className="mm-login-footer">
              Already Have An Account?{' '}
              <a href="/login" className="mm-link">
                Login
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordRequest;
